import { createAsyncAction } from 'utils/reduxUtils';

import { FetchHistorySuccessPayload } from './types';

export const fetchHistory = createAsyncAction<void, FetchHistorySuccessPayload, void>(
  'aiWriter/fetchHistory'
);
